<template>
    <div class="empty-state">
        <img class="empty-state-img" :src="$t(`${page}.${state}.image`)" />
        <div class="empty-state-message">
            <h3>{{ $t(`${page}.${state}.title`, params) }}</h3>
            <p v-html="$t(`${page}.${state}.message`, params)" />
        </div>

        <DsTextButton
            v-if="hasAction"
            class="empty-state-button"
            @click="$emit('buttonEvent')"
        >
            {{ $t(`${page}.${state}.action`) }}
        </DsTextButton>
    </div>
</template>

<script>
export default {
    props: {
        page: String,
        state: String,
        hasAction: Boolean,
        params: Object,
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .empty-state {
        display: flex;
        padding: $spacing-200;
        align-items: center;
        @media($small) {
            flex-direction: column;
            text-align: center;
        }
    }

    .empty-state-img {
        margin-right: $spacing-400;
        width: px-to-rem(150px);
    }

    .empty-state-message {
        flex: 1;
        margin: $spacing-200 0;
    }

    .empty-state-message p {
        flex: 1
    }

    [dir=rtl] {
        .empty-state-img {
            margin-left: $spacing-400;
            margin-right: 0;
        }
    }
</style>
